<template>
        <b-modal size="lg" :title="caption" class="modal-info" v-model="dataShow" @ok="onConfirmMultipleUserBookingClick" :ok-title="Core.Definition.getDefinition('Enregistrer')" ok-variant="primary" :cancel-title="Core.Definition.getDefinition('Annuler')" cancel-variant="light">
            <Request
                    ref="request"
                    method="POST"
                    root="/event-booking-panel/multi-book"
                    :onRequestSuccess="requestSuccess"
                    :onRequestError="requestError">
                <slot slot="body">
                    <MultipleUserBooking ref="multipleUserBooking"></MultipleUserBooking>
                    <b-alert variant="danger" show v-if="dataAlert.show">{{dataAlert.message}}</b-alert>
                </slot>
            </Request>
        </b-modal>
</template>

<script>
    import MultipleUserBooking from './MultipleUserBooking'
    import Request from './Request'
    import InstanceSelector from './InstanceSelector'
    import InputSelect from './InputSelect'
    import InputText from './InputText'
    import InputPhone from './InputPhone'
    import InputDatePicker from './InputDatePicker'
    import CForm from './CForm'
  export default {
      name: 'ModalMultipleUserBooking',
      components: {
          Request,
          InstanceSelector,
          InputSelect,
          InputDatePicker,
          InputText,
          InputPhone,
          CForm,
          MultipleUserBooking
      },
      props: {
          caption: {
              type: String,
              default: ''
          },
          message: {
              type: String,
              default: ''
          },
          root: {
              type: String,
              default: ''
          }
      },
      watch: {
      },
      mounted() {
      },
      data: () => {
          return {
              Core: window.Core,
              Mantle: window.Mantle,
              dataShow: false,
              dataAlert: {
                  show: false,
                  message: ''
              }
          }
      },
      computed: {
          isEmpty() {
              return this.$refs.multipleUserBooking.isEmpty
          }
      },
      methods: {
          open(eventDateOptions) {
              this.dataShow = true
              this.$nextTick(() => {
                  this.$refs.multipleUserBooking.userBookings = []
                  this.$refs.multipleUserBooking.eventDateOptions = eventDateOptions
              })
          },
          onConfirmMultipleUserBookingClick(e) {
              e.preventDefault()
              if (this.$refs.multipleUserBooking.isEmpty === false) {
                  if (this.$refs.multipleUserBooking.isValid) {
                      this.dataAlert.show = false
                      this.$refs.request.clearArgs()
                      this.$refs.request.addArg('bookingSummary', JSON.stringify(this.$refs.multipleUserBooking.dataUserBookings))
                      this.$refs.request.request()
                  } else {
                      this.dataAlert.message = Core.Definition.getDefinition('Vous devez compléter les informations de réservation.')
                      this.dataAlert.show = true
                  }
              } else {
                  this.dataAlert.message = Core.Definition.getDefinition('Vous devez ajouter au moins une réservation')
                  this.dataAlert.show = true
              }
          },
          requestSuccess(data) {
              this.$refs.multipleUserBooking.userBookings = []
              this.$refs.request.clearArgs()
              this.$emit('onMultipleUserBookingSuccess')
              this.dataShow = false
          },
          requestError() {

          }
      }
  }
</script>